import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/settings/account")({
  beforeLoad: ({ location }) => {
    const p = location.pathname.replace(/\/$/, "")
    if (p === "/settings/account") {
      throw redirect({ to: "/settings/account/profile" })
    }
  },
  component: () => <Outlet />,
})
